// Business types
export interface Business {
  id: number
  ownerId: number
  name: string
  description?: string
  address: string
  contactNumber: string
  businessType: string
  logoUrl?: string
  qrCode: string
  isAcceptingOrders: boolean
  isActive: boolean
  slug?: string
  taxFee?: number
  color?: string
  createdAt: string
  updatedAt: string
}

export interface CreateBusinessData {
  slug?: string
  name: string
  description?: string
  address: string
  contactNumber: string
  businessType: string
  isActive?: boolean
  isAcceptingOrders?: boolean
  color?: string
}

export interface UpdateBusinessData {
  name?: string
  description?: string
  address?: string
  contactNumber?: string
  businessType?: string
  isActive?: boolean
  isAcceptingOrders?: boolean
  slug?: string
  taxFee?: number
  color?: string
}

export const BUSINESS_TYPES = [
  'restaurant',
  'cafe',
  'bakery',
  'fast_food',
  'food_truck',
  'catering',
  'other'
] as const

export type BusinessType = typeof BUSINESS_TYPES[number]

export const BUSINESS_TYPE_LABELS: Record<BusinessType, string> = {
  restaurant: 'مطعم',
  cafe: 'مقهى',
  bakery: 'مخبز',
  fast_food: 'وجبات سريعة',
  food_truck: 'عربة طعام',
  catering: 'تقديم طعام',
  other: 'أخرى'
}

// Admin-related types (previously in admin.ts)
export interface BusinessOwner {
  id: number
  phoneNumber: string
  name: string
  email?: string
  userRole: string
  isActive: boolean
  businessId?: number
  createdAt: string
  updatedAt: string
  businesses?: Business[]
}

// Business interface extension for admin view
export interface BusinessWithStats extends Business {
  orderCount?: number
}


export interface Campaign {
  id: number
  businessId: number
  name: string
  description?: string
  qrCode: string
  isActive: boolean
  visits: number
  orders: number
  conversionRate: number
  createdAt: string
  updatedAt: string
}

export interface SystemStats {
  totalUsers: number
  totalBusinesses: number
  totalOrders: number
  totalRevenue: number
  pendingPayments: number
  monthlyGrowth: {
    users: number
    businesses: number
    orders: number
    revenue: number
  }
}

export interface OrderSummary {
  id: number
  businessName: string
  customerName: string
  customerPhone: string
  totalAmount: number
  status: OrderStatus
  orderType: OrderType
  createdAt: string
}

// Enums
export type PaymentStatus = 'pending' | 'approved' | 'rejected'
export type OrderStatus = 'pending' | 'preparing' | 'ready' | 'completed' | 'cancelled'
export type OrderType = 'pickup' | 'delivery'
